export const videos = [
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/196c84839247a64c5cfb79afa4346b35/manifest/video.m3u8',
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/3619a192ef394851364e157c88dcdb74/manifest/video.m3u8',
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/effa84fe70a4b71dc05129184d98fc1c/manifest/video.m3u8',
]

export const posters = [
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/196c84839247a64c5cfb79afa4346b35/thumbnails/thumbnail.jpg',
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/3619a192ef394851364e157c88dcdb74/thumbnails/thumbnail.jpg',
  'https://customer-3ra3i5fcxqoirydx.cloudflarestream.com/effa84fe70a4b71dc05129184d98fc1c/thumbnails/thumbnail.jpg',
]
